module.exports = __webpack_public_path__ + "static/img/C4D0005.0271f0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0005.jpg
// module id = 7LKk
// module chunks = 0